<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('inventory status')"
      :columns="columns"
      :column_search="true"
      resource_url="/inventory/status"
      :on_created_row="on_created_row"
      page_length="50"
    >
      <template #item="item">
        <div class="card">
          <!-- <div class="card-image">
            <figure
              class="image is-64x64 m-auto"
              @click="product_details(item)"
            >
              <v-lazy-image
                v-if="item.image"
                :src="`${api_host}/drive/static/${item.image}`"
              />
              <img
                v-else
                src="https://icon-library.com/images/product-icon-png/product-icon-png-11.jpg"
              />
            </figure>
          </div> -->
          <div class="card-header">
            <div class="card-header-title has-text-centered">
              {{ item.product.name }}
            </div>
          </div>
          <div class="card-content px-0" @click="product_details(item)">
            <div class="media">
              <div class="media-content">
                <div class="title is-6 has-text-centered">
                  <div
                    class="tags mb-0"
                    v-for="(grp, gidx) in item.grouped"
                    :key="gidx"
                  >
                    <span class="tag is-medium">{{ grp.quantity }}</span>
                    <div class="tag is-info">
                      {{ grp.warehouse }}
                    </div>
                  </div>
                </div>
                <div class="subtitle is-6 has-text-centered">
                  <span
                    class="tag is-medium"
                    :class="{
                      'is-primary':
                        item.quantity >
                        (item.product.settings.alert_on_inventory_limit || 5),
                      'is-warning':
                        item.quantity >= 0 &&
                        item.quantity <=
                          (item.product.settings.alert_on_inventory_limit || 5),
                      'is-danger': item.quantity < 0,
                    }"
                    >{{ item.quantity }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template> -->
    </generic-table>
    <product-status-modal ref="product_status_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  format_date_time,
} from "@/utils";
import ProductStatusModal from "./product_status_modal/Index.vue";

export default {
  name: "InventoryMovementDatatable",
  components: { GenericTable, ProductStatusModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("quantity"),
          searchable: false,
          data: (row) => {
            if (row.quantity < 0)
              return `<span class="has-text-danger">${row.quantity}</span>`;
            else if (row.quantity == 0)
              return `<span class="has-text-warning">${row.quantity}</span>`;
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            else return `<span class="has-text-primary">${row.quantity}</span>`;
          },
        },
        {
          title: v.$t("product"),
          name: "name",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.product.name || "";
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          data: (row) => {
            if (row.grouped) {
              let r = row.grouped.reduce((acc, cur) => {
                let color = "";
                if (cur.quantity < 0) color = "is-danger";
                else if (cur.quantity == 0) color = "is-warning";
                else color = "is-primary";
                return `${acc}<div class="field is-grouped is-grouped-multiline">
  <div class="control">
    <div class="tags has-addons">
      <span class="tag is-dark">${cur.warehouse || v.$t("no warehouse")}</span>
      <span class="tag ${color}">${cur.quantity}</span>
    </div>
  </div>`;
              }, "");
              return r;
            } else return "";
          },
        },
        // {
        //   title: v.$t("data"),
        //   // name: "name",
        //   searchable: false,
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //   },
        // },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.product.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  v.$refs.product_status_modal.show_modal(e.detail.uuid);
                },
              },
              // {
              //   args: { uuid: row.uuid },
              //   tooltip: v.$t("delete"),
              //   icon: "fa fa-trash",
              //   icon_class: "is-small has-text-danger",
              //   click: (e) => {
              //     let uuid = e.detail.uuid;
              //     confirm_deletion_dialog(
              //       v.$t("are you sure to delete movement?"),
              //       v,
              //       () => {
              //         del("/inventory/movement", { uuid: uuid })
              //           .then(() => {
              //             v.refresh();
              //           })
              //           .catch((error) => {
              //             error_message(error);
              //           });
              //       }
              //     );
              //   },
              // },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date_time,
    format_currency,
    create() {
      let v = this;
      v.$refs.inventory_movement_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    on_created_row(row, data) {},
    product_details(item) {
      // console.log("product_details", item);
      let v = this;
      v.$refs.product_status_modal.show_modal(item.product.uuid);
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
